import React, { useState } from "react";
import "./CurrentOpening.css"; // Import CSS file
import blogImg1 from "../Assests/img47.jpeg"; // Add actual images in assets folder
import blogImg2 from "../Assests/img48.jpeg";
import blogImg3 from "../Assests/img49.jpeg";
import blogImg4 from "../Assests/img50.jpeg";
import blogImg5 from "../Assests/img32.jpeg";
import axios from "axios";

const blogData = [
  {
    id: 1,
    image: blogImg1,
    title: "Pharmasist",
    description:
      " A Pharmacist dispenses medications, counsels patients, and ensures safe drug use.",
    jobExp:
      "1️⃣ Pharmacy Incharge / Supervisor – Minimum 5+ years of experience, 2️⃣ Senior Pharmacist – Minimum 4+ years of experience,  3️⃣ Jr. Pharmacist  – Minimum 0 - 2+ years of experience,  4️⃣ Pharma Aids – Minimum 0 - 2+ years of experience ",
    jobRole:
      " HospiPharma is hiring for multiple roles in the pharmacy sector. The Pharmacy Incharge/Supervisor will manage daily operations, supervise staff, ensure compliance, and maintain inventory. The Senior Pharmacist will be responsible for dispensing medicines, advising patients, managing stock, and training junior staff. The Jr. Pharmacist will handle prescription verification, medication preparation, and patient education while ensuring pharmacy safety. The Pharma Aids will assist pharmacists in dispensing medications, managing inventory, processing prescriptions, and maintaining a clean pharmacy environment. Each role plays a crucial part in delivering quality healthcare services efficiently and professionally.",
    responsibility:
      "1️⃣ Pharmacy In-Charge Responsibilities: The Pharmacy In-Charge manages staff, ensures smooth operations, and maintains patient care quality. They counsel patients on medication use, verify prescriptions, and address concerns. They also ensure medication safety and prevent dispensing errors.|  2️⃣ Senior Pharmacist Responsibilities: A Senior Pharmacist dispenses medications, verifies prescriptions, and advises patients. They manage inventory, track stock, and handle expired medicines. They oversee pharmacy operations, supervise staff, and ensure compliance. Additionally, they train and mentor junior pharmacists. | 3️⃣ Pharma Aids Responsibilities: Pharma Aids assist in medication dispensing, process prescriptions, and maintain inventory. They support customers, address queries, and keep the pharmacy organized. They also help ensure safety and smooth daily operations.",
  },
  {
    id: 2,
    image: blogImg2,
    title: "Accountant",
    description:
      "An accountant manages financial records, budgeting, and compliance.",
    jobExp: "Minimum 2+ year of Experience",
    jobRole:
      "🔹 Financial Management: Maintain accurate records of transactions, budgets, and tax filings. 🔹 Reporting & Compliance: Prepare financial statements and ensure GST and income tax compliance. 🔹 Budgeting & Forecasting: Analyze financial trends and assist in planning. 🔹 Auditing & Reconciliation: Conduct internal audits and match financial records with bank statements. 🔹 Data Analysis: Provide insights and financial recommendations to management.",
    responsibility:
      "🔹 📊 Financial Reporting: Generate balance sheets, income statements, and cash flow reports. 🔹 💰 Tax Compliance: Ensure timely tax filings and adherence to financial regulations. 🔹 🏦 Bank Reconciliation: Match company records with bank transactions. 🔹 📦 Inventory & Cost Management: Track stock levels and analyze costs. 🔹 🔄 Payroll & Accounts Payable: Manage employee salaries and vendor payments.",
},

  {
    id: 3,
    image: blogImg3,
    title: "Ware House Manger",
    description:
      "A Warehouse Manager oversees inventory, logistics, and storage operations.",
    jobExp: "Warehouse Manager Experience Required: 5 to 10+ years",
    jobRole:
      "🔹 Oversee Operations: Manage daily warehouse activities to ensure efficiency.🔹 Inventory Management: Supervise stock levels, storage, and movement. 🔹 Team Leadership: Train, guide, and evaluate warehouse staff. 🔹 Safety Compliance: Enforce safety regulations and workplace protocols. 🔹 Coordination & Communication: Work with suppliers, logistics, and other departments.",
    responsibility:
      "🔹 📦 Inventory Control: Conduct audits, track stock levels, and prevent discrepancies. 🔹 🚛 Shipping & Receiving: Monitor incoming and outgoing goods with accuracy. 🔹 👨‍👩‍👧‍👦 Workforce Management: Assign tasks, schedule shifts, and optimize labor. 🔹 ⚡ Operational Efficiency: Improve workflow to enhance productivity and cost savings. 🔹 📊 Compliance & Reporting: Maintain records, analyze data, and ensure policy adherence.",
  },
  {
    id: 4,
    image: blogImg4,
    title: "Ware House Executive",
    description:
      "A Warehouse Executive handles inventory management, stock movement, and warehouse.",
    jobExp:
      "Warehouse Executive Experience Required: 📌 3 to 7+ years in warehouse management and operations.",
    jobRole:
      "🔹 📦 Inventory Management: Ensure stock accuracy, proper storage, and efficient inventory control. 🔹 🚛 Receiving & Dispatching: Oversee goods receipt, inspection, and timely dispatch. 🔹 👨‍💼 Staff Supervision: Assist in managing and training warehouse staff for smooth operations. 🔹 🏭 Warehouse Operations: Monitor workflow efficiency and maintain organized warehouse processes. 🔹 📝 Documentation & Reporting: Maintain accurate records of stock movement, receipts, and shipments.",
    responsibility:
      "🔹 🔍 Problem-Solving: Identify operational issues and implement corrective measures. 🔹 ⚠️ Safety Compliance: Ensure adherence to workplace safety standards and proper equipment usage. 🔹 📊 Stock Audits: Conduct regular audits to prevent losses and ensure inventory accuracy. 🔹 💬 Communication & Coordination: Collaborate with suppliers, logistics teams, and management. 🔹 💰 Cost Control: Optimize resources to reduce warehouse expenses and improve efficiency.",
  },
  {
    id: 5,
    image: blogImg5,
    title: "Sales Executive",
    description:
      "A Sales Executive drives sales, builds client relationships, and promotes products or services.",
    jobExp: "Sales Executive 1+ years in pharmaceutical sales or related fields.",
    jobRole:
      "🔹 📊 Sales & Business Development: Promote and sell pharmaceutical products to healthcare professionals like doctors and pharmacists. 🔹 📑 Company & Product Knowledge: Maintain an in-depth understanding of the company’s products, market trends, and competitors. 🔹 💼 Client Relationship Management: Build and sustain strong relationships with healthcare specialists and pharmacy clients. 🔹 📈 Sales Target Achievement: Work towards meeting and exceeding sales targets while focusing on revenue growth. 🔹 🎓 Educational Qualification: Diploma in Science or a B.Sc. graduate, preferably in a related field.",
    responsibility:
      "🔹 🗣️ Communication Skills: Exhibit excellent verbal and written communication skills for effective client engagement. 🔹 🏥 Healthcare Industry Knowledge: Stay updated on pharmaceutical trends, regulations, and healthcare advancements. 🔹 📊 Sales & Marketing Abilities: Utilize effective sales strategies to attract and retain clients. 🔹 🔄 Adaptability & Flexibility: Keep up with industry changes, new product launches, and evolving market demands.🔹📌 Closing Sales: Follow up with potential clients, negotiate contracts, and finalize deals successfully.",
  },
];

const CurrentOpening = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    education: "",
    experience: "",
    resume: null,
  });

  const [submissionStatus, setSubmissionStatus] = useState({
    submitted: false,
    message: "",
    isError: false
  });

  // Open Job Details Modal
  const openModal = (job) => {
    setSelectedJob(job);
    setShowForm(false);
    setSubmissionStatus({
      submitted: false,
      message: "",
      isError: false
    });
  };

  // Close Job Details Modal
  const closeModal = () => {
    setSelectedJob(null);
  };

  // Open Application Form Modal
  const openForm = () => {
    setShowForm(true);
    setSubmissionStatus({
      submitted: false,
      message: "",
      isError: false
    });
  };

  // Close Application Form Modal
  const closeForm = () => {
    setShowForm(false);
    setFormData({
      name: "",
      phone: "",
      email: "",
      education: "",
      experience: "",
      resume: null,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedJob) {
      setSubmissionStatus({
        submitted: true,
        message: "No job selected. Please select a job before applying.",
        isError: true
      });
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("phone", formData.phone);
    data.append("email", formData.email);
    data.append("education", formData.education);
    data.append("experience", formData.experience);
    data.append("resume", formData.resume);
    data.append("jobTitle", selectedJob.title);
    data.append("jobCategory", selectedJob.title);

    try {
      const response = await axios.post(
        "https://pharmabackend-1.onrender.com/api/job-application",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.alreadyApplied) {
        setSubmissionStatus({
          submitted: true,
          message: "You have already applied for this position.",
          isError: true
        });
      } else {
        setSubmissionStatus({
          submitted: true,
          message: "Application submitted successfully!",
          isError: false
        });
        setFormData({
          name: "",
          phone: "",
          email: "",
          education: "",
          experience: "",
          resume: null,
        });
        // Auto-close form after 2 seconds if successful
        setTimeout(() => {
          setShowForm(false);
        }, 2000);
      }
    } catch (error) {
      setSubmissionStatus({
        submitted: true,
        message: error.response?.data?.message || "Error submitting application",
        isError: true
      });
      console.error(error);
    }
  };


  return (
    <section className="blog-section">
      <h2 className="blog-title">Current Openings</h2>
      <div className="blog-container">
        {blogData.map((item) => (
          <div key={item.id} className="blog-card">
            <div className="blog-image-wrapper">
              <img src={item.image} alt="Job" className="blog-image" />
            </div>
            <div className="blog-content">
              <h3 className="blog-heading">{item.title}</h3>
              <p className="blog-description">{item.description}</p>
              <button className="blog-btn" onClick={() => openModal(item)}>
                Click Me
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Job Details Modal */}
      {selectedJob && !showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={closeModal}>
              X
            </button>
            <h2>{selectedJob.title}</h2>
            <p>
              <strong style={{ color: "#ff5500" }}>Description:</strong>{" "}
              {selectedJob.description}
            </p>
            <p>
              <strong style={{ color: "#ff5500" }}>Experience Required:</strong>{" "}
              {selectedJob.jobExp}
            </p>
            <p>
              <strong style={{ color: "#ff5500" }}>Job Role:</strong>{" "}
              {selectedJob.jobRole}
            </p>
            <p>
              <strong style={{ color: "#ff5500" }}>Responsibilities:</strong>{" "}
              {selectedJob.responsibility}
            </p>
            <button className="apply-btn" onClick={openForm}>
              Apply Now
            </button>
          </div>
        </div>
      )}

      {/* Application Form Modal */}
      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content form-modal">
            <button className="close-btn" onClick={closeForm}>
              X
            </button>
            <h2>Apply for {selectedJob?.title}</h2>

            {submissionStatus.submitted && (
              <div className={`submission-feedback ${submissionStatus.isError ? 'error' : 'success'}`}>
                {submissionStatus.message}
              </div>
            )}
            
            {!submissionStatus.submitted || submissionStatus.isError ? (
            <form className="apply-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Mobile No"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="education"
                placeholder="Education Qualification"
                value={formData.education}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="experience"
                placeholder="Work Experience"
                value={formData.experience}
                onChange={handleChange}
                required
              />
              <input
                type="file"
                name="resume"
                accept=".pdf, .jpg, .jpeg"
                onChange={handleFileChange}
                required
              />
              <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            ) : null}
          </div>
        </div>
      )}
    </section>
  );
};

export default CurrentOpening;
